import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getPartnerInfo } from "../api/pfs";
import { IAPIError } from "../interfaces/common";
import { ISubscriptionPartnerInfo } from "../interfaces/subscriptions";

export const partnerInfoQueryKey = ['partnerInfo'] as const;

export const usePartnerInfo = (
  enabled?: boolean
): UseQueryResult<ISubscriptionPartnerInfo, IAPIError> => {
  return useQuery<ISubscriptionPartnerInfo, IAPIError>({
    queryKey: partnerInfoQueryKey,
    queryFn: ({ signal }) => getPartnerInfo(signal),
    enabled
  });
};
